import styled, { css } from 'styled-components';
import { deviceWidths } from '../../variables/widths.js';

var ConceptBadge = styled.div.withConfig({
  displayName: "style__ConceptBadge",
  componentId: "sc-l759vu-0"
})(["display:inline-flex;width:auto;", ";img{width:auto;@media screen and (max-width:", "){height:", ";};@media screen and (min-width:", "){height:", ";};};"], function (props) {
  return props.onClick && css(["cursor:pointer;"]);
}, deviceWidths.tabletMax, function (props) {
  return props.mobileSize ? "".concat(props.mobileSize, "px") : '30px';
}, deviceWidths.tablet, function (props) {
  return props.desktopSize ? "".concat(props.desktopSize, "px") : '45px';
});

export { ConceptBadge };
//# sourceMappingURL=style.js.map
